/* eslint-env browser */
import axios from 'axios'
import * as React from 'react'

import withTranslator from '../../../client/clientjs/components/TranslatorProvider'

const PropTypes = require('prop-types')
const Table = require('../../../client/clientjs/components/Table')

class RankingNoRoundTable extends React.Component {
  constructor(props) {
    super(props)

    const { translate } = props

    this.state = {
      ranking: [],
      columns: [
        {
          name: 'rank',
          display: 'Rank',
          getCellRawValue: row => row.rank,
          getCellValue: row => {
            switch (row.rank) {
              case 1:
                return `${row.rank} 🥇`
              case 2:
                return `${row.rank} 🥈`
              case 3:
                return `${row.rank} 🥉`
              default:
                return row.rank
            }
          },
          isSortable: true,
          isTextCentered: true,
          isBold: true,
        },
        {
          name: 'teamName',
          display: 'Team',
          isSortable: true,
          getCellValue: row => [
            <span key="team-name-1" className="has-margin-right-xsmall">
              {row.teamName}
            </span>,
            <a
              key="team-name-2"
              href={`/contests-force-web/${row.contestSeoName}/teams/${row.teamId}`}
              target="_blank"
              rel="noreferrer"
            >
              <i className="fas fa-external-link" style={{ fontSize: '0.8em' }} />
            </a>,
          ],
          getCellRawValue: row => row.teamName.toLowerCase(),
          getCellSubRowValue: (row, subRow, subRowIdx) => {
            if (subRow.isBonus) {
              return (
                <div>
                  <i
                    className={
                      subRow.score > 0 ? 'fas fa-star fa-lg has-text-primary' : 'fas fa-pennant fa-lg has-text-danger'
                    }
                  >
                    &nbsp;
                  </i>
                  {subRow.message}
                </div>
              )
            }
            if (subRow.isFishQuotaBonus) {
              return (
                <div>
                  <i className="fas fa-star fa-lg has-text-primary">&nbsp;</i>
                  {`${subRow.fishName || ''} / Quota Bonus`}
                </div>
              )
            }
            if (subRow.isDifferentSpeciesQuotaBonus) {
              return (
                <div>
                  <i className="fas fa-star fa-lg has-text-primary">&nbsp;</i>
                  {`Bonus ${subRow.differentSpeciesCountForBonus} espèces`}
                </div>
              )
            }
            return (
              <div>
                <article className="media">
                  {subRow.fishCatch && (
                    <figure className="media-left">
                      <p className="image is-64x64">
                        <a
                          href={`/users/${subRow.userId}/catches/${subRow.fishCatchId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {subRow.fishCatch.medias && subRow.fishCatch.medias.length > 0 && (
                            <img
                              src={subRow.fishCatch.medias[0].url_100}
                              style={{ maxHeight: '100%' }}
                              className="has-object-fit-contain"
                              height="50"
                              alt="fish catch"
                            />
                          )}
                        </a>
                      </p>
                    </figure>
                  )}
                  {subRow.fishCatch && (
                    <div className="media-content">
                      <div className="content">
                        {subRow.fishCatch.speciesCustomName ||
                          (subRow.fishCatch.fish && subRow.fishCatch.fish.names && subRow.fishCatch.fish.names.length
                            ? subRow.fishCatch.fish.names[0].value
                            : '')}
                        <br />
                        {subRow.fishCatch.size ? `${subRow.fishCatch.size}cm` : ''}
                        &nbsp;
                        <a
                          href={`/users/${subRow.userId}/catches/${subRow.fishCatchId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-link"
                        >
                          <i className="far fa-external-link">&nbsp;</i>
                        </a>
                      </div>
                    </div>
                  )}
                  {!subRow.fishCatch && (
                    <div>
                      <small>{translate('ranking.catchNotFound')}</small>
                    </div>
                  )}
                </article>
              </div>
            )
          },
        },
        {
          name: 'score',
          display: 'POINTS',
          isTextCentered: true,
          isBold: true,
          isSortable: true,
          getCellValue: row => row.score,
          getCellSubRowValue: (row, subRow, subRowIdx) => {
            const { keepOnlyTop } = row
            return !keepOnlyTop || subRowIdx < keepOnlyTop ? subRow.score : `(${subRow.score})`
          },
        },
      ],
    }
    this.onRowClick = this.onRowClick.bind(this)
  }

  componentWillMount() {
    const { ranking, teamsById } = this.props
    const { contestSeoName } = this.props

    this.setState({
      ranking: ranking.map(row => {
        const team = teamsById[row.teamId]
        if (team) {
          row.teamNationality = team.members.find(m => m.isCaptain) || {}
        }
        row.contestSeoName = contestSeoName
        return row
      }),
    })
  }

  onRowClick(row) {
    const { contestId, teamsById } = this.props
    const { ranking } = this.state

    const rowRankingIndex = ranking.findIndex(elt => elt.teamId === row.teamId)
    if (rowRankingIndex === -1) {
      return
    }
    const rowRanking = ranking[rowRankingIndex]
    ranking[rowRankingIndex] = {
      ...rowRanking,
      isDisplayed: !rowRanking.isDisplayed,
      subRowsLoading: true,
    }
    this.setState({
      ranking,
    })
    if (!rowRanking || rowRanking.subRowsLoading) {
      return
    }
    axios
      .get(`/api/contests/${contestId}/individualParticipations`, {
        params: { userIds: ((teamsById[row.teamId] || {}).members || []).map(elt => elt.id) },
      })
      .then(response => {
        const { data = {} } = response
        const { bonuses = [], participations = [], fishesQuotaBonuses = [], differentSpeciesQuotasBonuses = [] } = data

        const subRows = bonuses
          .map(elt => ({
            ...elt,
            isBonus: true,
          }))
          .concat(participations)
          .concat(
            fishesQuotaBonuses
              .filter(elt => elt.fishQuotaBonus > 0)
              .map(elt => ({
                ...elt,
                isFishQuotaBonus: true,
                score: elt.fishQuotaBonus,
              }))
          )
          .concat(
            differentSpeciesQuotasBonuses
              .filter(elt => elt.bonus > 0)
              .map(elt => ({
                ...elt,
                isDifferentSpeciesQuotaBonus: true,
                score: elt.bonus,
              }))
          )
          .sort((a, b) => b.score - a.score)

        this.setState(prevState => {
          const newRanking = prevState.ranking
          newRanking[rowRankingIndex] = {
            ...newRanking[rowRankingIndex],
            subRows,
            subRowsLoading: false,
          }
          return {
            ranking: newRanking,
          }
        })
      })
  }

  render() {
    const { scoreLessIsMore } = this.props
    const { columns, ranking } = this.state

    return (
      <Table
        rows={ranking}
        columns={columns}
        getRowKey={row => row.teamId}
        onRowClick={this.onRowClick}
        getSubRows={row => (row.isDisplayed ? row.subRows || [] : [])}
        getSubRowKey={(row, subRow) => `${row.teamId}-subrow-${subRow.id}`}
        tableClass="is-size-7 is-size-8-mobile is-self-centered"
        defaultSortBy="score"
        defaultSortASC={scoreLessIsMore}
        isFullWidth
      />
    )
  }
}

RankingNoRoundTable.propTypes = {
  translate: PropTypes.func.isRequired,
  ranking: PropTypes.array,
  teamsById: PropTypes.object,
  contestId: PropTypes.string.isRequired,
  contestSeoName: PropTypes.string.isRequired,
  scoreLessIsMore: PropTypes.bool,
}

RankingNoRoundTable.defaultProps = {
  teamsById: {},
  ranking: [],
  scoreLessIsMore: false,
}

module.exports = withTranslator(RankingNoRoundTable)
